exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quotePMargin[data-v-370a4ddc]{margin:0;text-align:left!important}.md-direction-bottom-right[data-v-370a4ddc]{width:18%!important}.md-flex-xsmall-100[data-v-370a4ddc]{min-width:100%;flex:0 1 100%}.center[data-v-370a4ddc]{text-align:center}.b-form-input-container[data-v-370a4ddc]{margin:4px 0 12px!important}.activeClass[data-v-370a4ddc]{display:none}.error[data-v-370a4ddc]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-370a4ddc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/clientUserMaster/upsertClientUser.vue
// module id = 1504
// module chunks = 0